export const DEPARTMENTS_SUCCESS = 'gustav/departments/FETCH_SUCCESS';
export const DEPARTMENTS_ERROR = 'gustav/departments/FETCH_ERROR';
